import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

class EmisorEditActions extends PureComponent {
  get customization() {
    const { data = {} } = this.props;

    return {
      pathname: `/app/emisores/${data.id}/personalizar`,
      state: {
        data: { ...data },
      },
    };
  }

  get csd() {
    const { data = {} } = this.props;

    return {
      pathname: `/app/emisores/${data.id}/certificados`,
      state: {
        data: { ...data },
      },
    };
  }

  get info() {
    const { data = {} } = this.props;

    if (data.sector_primario_is_productor === true) {
      return {
        pathname: `/app/emisores/sector-primario/${data.id}/editar`,
        state: {
          data: { ...data },
        },
      };
    }

    return {
      pathname: `/app/emisores/${data.id}/editar`,
      state: {
        data: { ...data },
      },
    };
  }

  render() {
    const { data = {} } = this.props;

    const isProductorSectorPrimario = data?.sector_primario_is_productor === true;

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={true}
      >
        {Guardian.allows('emisor.personalizar') && (
          <Link to={this.customization}>
            <Button
              type="button"
              variant="secondary"
            >
              Personalizar
            </Button>
          </Link>
        )}

        <Dropdown.Toggle
          split
          variant="secondary"
          id="dropdown-split-basic"
        />

        <Dropdown.Menu>
          {Guardian.allows('emisor.actualizar.csd') && !isProductorSectorPrimario && (
            <Dropdown.Item
              as={Link}
              to={this.csd}
            >
              Subir nuevo CSD
            </Dropdown.Item>
          )}

          {Guardian.allows('emisor.editar') && (
            <Dropdown.Item
              as={Link}
              to={this.info}
            >
              Editar información fiscal
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default EmisorEditActions;
